import {IPubCtx} from "/@lib@/wsp/wspMetaUi.js";
import {SRC} from "/@lib@/wsp/src.js";
import {ERROR} from "/@lib@/core/errorReport.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";
import {GenAction} from "/@back@/wsp/views/gen/genActions.js";
import {MsgOver} from "/@back@/commons/basis.js";
import {JSkinPackInstalled} from "/@lib@/wsp/pack.js";
import {STYLER} from "/@lib@/styler/styler.js";
import "/@back@/styler/views/views_Perms.js";
import {EGenStatus} from "/@lib@/wsp/item.js";
import {IO, PublicEndPoint} from "/@lib@/commons/io/io.js";

export class StylerInstallSkinsetAction extends GenAction {

	static SINGLETON = new StylerInstallSkinsetAction();

	constructor(id?: string) {
		super(id || "stylerInstallSkinset");
		this._label = "Installer";
		this._icon = "/@skin@/styler/views/generators/install.svg";
		this._description = "Installer le dernier habillage graphique compilé";
		this._hideForStatuses = [EGenStatus.failed, EGenStatus.null];
		this.requireEnabledPerm("action.gen#install.genAsSkinPack")
	}

	async execute(ctx: IPubCtx, ev?: Event): Promise<any | 'noPreventDefault'> {
		try {
			/* Liste des URLs cibles additionnelles, partageant l'auth courante (ex : prl "depot" dans saas, dans une **autre** instance) */
			const LIST = "styler:installGenAsSkinpack:authenticatedZone:targetSvcUrls";

			let resp: true | Error = await new MsgOver().setCustomMsg("Veuillez patienter...", "info").showMsgOver(ctx.reg.env.uiRoot).waitFor(
				new Promise(async (resolve, refuse) => {
						try {
							let errorsDetailsArray: String[] = [];

							const targetLocal = await STYLER.installGenAsSkinpack(ctx.wsp, ctx.uiContext, SRC.srcRef(ctx.shortDesc), ctx.pubNode.codeGenStack, ctx.reg.env.uiRoot.lang)
							if (!targetLocal?.length)
								errorsDetailsArray.push("Install in current portlet failed or incomplete : " + JSON.stringify(targetLocal));

							const targetSvcUrls: string[] = ctx.reg.getList(LIST);
							if (targetSvcUrls?.length) {
								// Download
								const params = IO.qs("cdaction", "Download", "param", ctx.wsp.code, "refUri", SRC.srcRef(ctx.shortDesc), "codeGenStack", ctx.pubNode.codeGenStack);
								const content = await ctx.wsp.wspServer.config.wspGenUrl.fetch(params, "none");
								if (!content.ok) {
									errorsDetailsArray.push("Install in remote portlets failed - failed in download skin : " + content.error?.message);
								} else {
									// Push dans les cibles
									await Promise.all(targetSvcUrls.map(async (url) => {
										try {
											const resp = await new PublicEndPoint(IO.absoluteUrl(url), "same-origin").fetchJson<any>(IO.qs("cdaction", "Install"), {
												method: "PUT",
												body: await content.blob(),
											}) as { pack: JSkinPackInstalled };
											if (!resp.pack)
												errorsDetailsArray.push(`Install in portlet '${url}' failed.`);
										} catch (e) {
											errorsDetailsArray.push(`Install in portlet '${url}' failed : "${e}"`);
											return ERROR.log(`Install in portlet '${url}' failed.`, e)
										}
									}));
								}
							}
							if (errorsDetailsArray.length == 0) {
								resolve(true);
							} else {
								refuse(new Error(Array.from(errorsDetailsArray.values()).join("\n")));
							}
						} catch (e) {
							refuse(new Error(e));
						}
					}
				)
			);
			if (resp === true) {
				POPUP.showNotifInfo("L'installation du skinpack s'est déroulée avec succès.\nVous pouvez maintenant l'utiliser (et l'activer) dans les ateliers concernés.", ctx.reg.env.uiRoot, {autoHide: 5000});
			} else
				throw resp;
		} catch (e) {
			return ERROR.report("L'installation du skinpack n'a pas pu aboutir ou s'est déroulé de façon partielle", e);
		}

	}
}
